<template>
  <div class="purchase-container"
       v-loading="isLoading">
    <div class="fixed-wrapper">
      <div class="order-property-wrapper">
        <ul class="order-property">
          <li class="name">物料名称</li>
          <li class="code">物料编码</li>
          <li class="quality">品项</li>
          <li class="brand">品牌</li>
          <li class="model">机型</li>
          <li class="module">模块</li>
          <li class="quantity">采购数量</li>
          <li class="price">单价</li>
        </ul>
      </div>
    </div>
    <div class="order-list-wrapper"
         v-if="purchaseList.length > 0">
      <div class="item-wrapper"
           v-for="(item,index) in purchaseList"
           :key="index">
        <div class="item-header">
          <div class="header-left">
            <span class="time">{{ item.docDueDate | date }}</span>
            <span>采购订单：{{ item.docEntry }}</span>
          </div>
          <div class="status">
            状态：{{ item.state | purchaseStatus }}
          </div>
        </div>
        <div class="item-content">
          <div class="order-list">
            <div class="order-item"
                 v-for="(item1, index1) in item.sapPurchaseOrderDetails"
                 :key="index1">
              <div class="name">{{item1.itemName}}</div>
              <div class="code">{{item1.itemCode}}</div>
              <div class="quality">
                <el-tag :type="item1.itemQualityName | qualityType"
                        size="mini">
                  {{ item1.itemQualityName }}
                </el-tag>
              </div>
              <div class="brand">{{item1.brand}}</div>
              <div class="model">{{item1.machine}}</div>
              <div class="module">{{item1.module}}</div>
              <div class="quantity">{{item1.quantity}}</div>
              <div class="price">{{item1.price}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="blank-replace"
         v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      purchaseList: [],
      isLoading: false
    };
  },
  created () {
    this.getPurchaseList()
  },
  methods: {
    getPurchaseList () {
      this.isLoading = true
      const params = {
        docEntry: '',
        material: '',
        state: 'Created',
        skipCount: 0,
        maxResultCount: 10
      }
      this.$http.get('/api/services/inquiryApp/purchaseOrder/GetSapAll', params)
        .then(res => {
          this.purchaseList = res.result.items
          this.isLoading = false
        })
        .catch(err => {
          console.log(err);
          this.$message.error('获取数据失败！')
          this.isLoading = false
        })
    },
  },
};
</script>
<style lang="less" scoped>
.purchase-container {
  width: 100%;
  overflow: auto;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.purchase-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.fixed-wrapper {
  width: 100%;
}

.order-property-wrapper {
  width: 100%;
  height: 45px;
  padding: 0 20px 0 20px;
  border-bottom: 1px solid #ededed;
  background-color: #f5f5f5;
  font-size: 14px;
  font-weight: 600;
  color: #2f343c;
  display: flex;
  align-items: center;
  .order-property {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .operation {
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.order-list-wrapper {
  width: 100%;
  height: calc(100% - 500px);
  background-color: #ffffff;
  overflow: auto;
  margin-top: 10px;
  font-size: 12px;
}
.item-wrapper {
  margin-top: 10px;
  border: 1px solid #ededed;
  &:first-child {
    margin-top: 0;
  }
  .item-header {
    height: 35px;
    padding: 0 20px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      height: 35px;
      display: flex;
      align-items: center;
      .time {
        margin-right: 30px;
      }
    }
  }
  .item-content {
    min-height: 45px;
    display: flex;
    padding: 0 20px;
    .order-list {
      width: 100%;
    }
  }
  .order-item {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
  }
}
.blank-replace {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #909399;
  border-bottom: 1px solid #ebeef5;
}
.name {
  width: 30%;
}
.code {
  width: 10%;
}
.quality {
  width: 10%;
  display: flex;
  align-items: center;
}
.brand {
  width: 10%;
}
.model {
  width: 10%;
}
.module {
  width: 10%;
}
.quantity {
  width: 10%;
}
.price {
  width: 10%;
}
</style>